"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateDid = exports.VersionT = exports.RecordTypesT = exports.PublicKeyT = exports.OpenAttestationDnsDidRecordT = exports.AlgorithmT = void 0;
var _runtypes = require("runtypes");
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// References https://www.w3.org/TR/did-core/#did-syntax
const validateDid = maybeDid => {
  const _maybeDid$split = maybeDid.split(":"),
    _maybeDid$split2 = _toArray(_maybeDid$split),
    did = _maybeDid$split2[0],
    methodName = _maybeDid$split2[1],
    methodSpecificIdParts = _maybeDid$split2.slice(2);
  const methodSpecificId = methodSpecificIdParts.join(":");
  if (did !== "did" || !methodName || !methodSpecificId || !/[a-z]+/.test(methodName)) return false;
  return true;
};
exports.validateDid = validateDid;
const RecordTypesT = exports.RecordTypesT = (0, _runtypes.Literal)("openatts");
const AlgorithmT = exports.AlgorithmT = (0, _runtypes.Union)((0, _runtypes.Literal)("dns-did"));
const VersionT = exports.VersionT = _runtypes.String;
const PublicKeyT = exports.PublicKeyT = _runtypes.String.withConstraint(maybeDid => {
  return validateDid(maybeDid) || `${maybeDid} is not a valid did`;
});
const OpenAttestationDnsDidRecordT = exports.OpenAttestationDnsDidRecordT = (0, _runtypes.Record)({
  type: RecordTypesT,
  algorithm: AlgorithmT,
  publicKey: PublicKeyT,
  version: VersionT
}).And((0, _runtypes.Partial)({
  dnssec: _runtypes.Boolean
}));